export let CommonEnum = {
  Yes: 'Yes',
  No: 'No',
  Allow: true
};

export let CommonEnums = {
  Yes: 'Yes',
  No: 'NO',
  Allow: true
};

export let ClientIdentifier = {
  PrioryGroup: 'PrioryGroup',
  Sunrise: 'Sunrise',
  SapCloud: 'SapCloud',
  NHSS: 'nhss'
};

export let VideoInterviewProvider = {
  Shine: 'Shine',
  LaunchPad: 'LaunchPad'
};
export let HistoryEventType = {
  CCLExport: 'CCL Export',
  CCLExportFailure: 'CCL Export Failure'
};

export let CsvClients = {
  MyDentist: 'MyDentist'
};

export var AssignJobMsgType =
{
  Assigned: "Assigned",
  Error: "Error",
  AlreadyExist: "AlreadyExist",
  AgencyError: "AgencyError"
}

export var SendSmsMessageType =
{
  Succeed: "Succeed",
  Failed: "Failed",
  MobileNotExist: "MobileNotExist"
}


export var AssessmentFormType =
{
  formA: 'A',
  formB: 'B',
  PreAssessmentForm: 'PreAssessmentForm'
}

export var ApplicationStage =
{
  first: 'First',
  second: 'Second'
}



export var StatusCode = {
  OK: 200,
  Error: 505,
  failure: 500,
  Restricted: 403,
  partialContent: 206,
  Conflict: 409,
  BadRequest: 400,
  Forbidden: 403,
  Created: 201,
  NotModified: 304,
  UnAuthorized:401,
   NotAcceptable: 406,
    NoContent: 204,
    PreconditionFailed: 412
}
export var EmailConfigured = {
  EmailInValid: 1,
}
export let EmailValidationMessageType = {
  Error: 1,
  Information: 2,
};

export let eEssJobFamily = {
  MedicalAndDental: "MedicalAndDental",
  ExecutiveLevel: "ExecutiveLevel",
  SeniorManagers: "SeniorManagers",
  AgendaforChange: "AgendaforChange",
  Other: "Other"
};

export let CopyData = {
  CopyOf: 'Copy of'
};

export let ListType = {
  List: 'List',
  Print: 'Print'
};

export let ExportType = {
  Excel: 'Excel',
  Word: 'Word'
};

export let AlignOrder = {
  Asc: 'Asc',
  Desc: 'Desc'
};

export enum SelectionType {
  Single = 1,
  Multiple = 2
}


export enum DocumentStatus {
  MarkCompleted = 8,
}

export enum AlertSessionVariables {
  AlertCategories = 'OppAlertCategories',
  AlertRegions = 'OppAlertRegions',
  AlertDepartments = 'OppAlertDepartments',
  AlertLocations = 'OppAlertLocations',
  AlertSalaries = 'OppAlertSalaries',
}

export let DashboardStatistics = {
  JobsAwaitingApproval: 1,
  JobsAwaitingApprovalUrl: '/Search/Jobs',
  JobsAdvertised: 2,
  JobsAdvertisedUrl: '/Search/Jobs',
  LiveJobs: 3,
  LiveJobsUrl: '/Search/Jobs',
  NewApplications: 4,
  NewApplicationsUrl: '/Search/Candidates',
  InterviewsWithCalendar: 5,
  InterviewsWithCalendarUrl: '/Search/Candidates',
  InterviewsWithOutCalendar: 6,
  InterviewsWithOutCalendarUrl: '/Search/Candidates',
  CandidatescompletedvideoInterviews: 7,
  CandidatesCompleted2ndStage: 8,
  CandidatesCompleted2ndStageUrl: '/Search/Candidates',
  ApplicationOfferedRatio: 9,
  ApplicationOfferedRatioUrl: '/Search/Candidates',
  OfferedAcceptedRatio: 10,
  OfferedAcceptedRatioUrl: '/Search/Candidates',
  OnBoarding: 11,
  OnBoardingUrl: "/WorkPlace/MyStarter/List",
  OffersMade: 12,
  OffersMadeUrl: "/Search/Candidates",
  InterviewsBookedUrl: "/InterviewsBooked/List",
  ApplicationStatuse: 13,
  ApplicationStatuseUrl: "/Search/Candidates",
}

export let StatisticsUrl = {
  JobsAdvertised: 2,
  LiveJobs: 3,
  NewApplications: 4,
  InterviewsWithCalendar: 5,
  InterviewsWithOutCalendar: 6,
  CandidatescompletedvideoInterviews: 7,
  CandidatesCompleted2ndStage: 8,
  ApplicationOfferedRatio: 9,
  OfferedAcceptedRatio: 10,
  OnBoarding: 11
};

export let FilterKeys = {
  FDMListingType: 'ListingType',
  ApplicationStatusId: 'ApplicationStatusId',
  FDMTLSType: 'TlsType',
  UserId: 'UserId',
};



export let FormType = {
  IsCompliancForm: 2,
  IsCompliancFormType: "Yes",
}


export var ImageDimensions = {
  Dim1200_250: '1200x250',
  Dim280_140: '280x140',
  Dim1900_250: '1900x250',
  Dim1200_500: '1200x500',
  Dim1900_140: '1900x140',
  Dim1280_720: '1280x720',
  Dim1152_648: '1152x648',
  Dim1024_576: '1024x576',
  Dim1920_1080: '1920x1080',
  Dim400x160: '400x160',
  Dim400x400: '400x400',


};

export let ReportType = {
  Ecni: 'Ecni',
  advert_Ecni: 'AdvertEcni'

};

export let ReportProcedureName = {
  Ecni: 'JT7_rpt_ECNI_report',
  advert_Ecni: 'JT7_rpt_advert_ECNI_report'

};

export let SectionNumber = {
  Personal: 1,
  CV: 8,
  Education: 2,
  Employment: 3,
  Declaration: 9,
  References: 4,
  EqualOpps: 5,
  Additional_Info: 6,
  CRB: 7,
  Multi_Upload: 12
};
export let ReasonTypes = {
  DeleteApplication: 'Delete Application',
  DeleteProfile: 'Delete Profile',
  WithdrawApplication: 'Withdraw Application'
};
export let ReasonNum = {
  DeleteApplication: 1,
  DeleteProfile: 2,
  WithdrawApplication: 3,
  StatusChange: 4
}

export let ReuqiredUpload = {
  Yes: 'Yes',
  No: 'No'
}
export let QuestionType = {
  Text: 'T',
  Single: 'S',
  Multiple: 'M',
  Date: "A",
}
export let ControlType = {
  Date: 'DATE',
  DateText: 'DT',
  ContactEmail: 'CONTACTEMAIL'
}

export let LookupType = {
  Departments: 'Departments',
  Divisions: 'Divisions',
  SchoolLocations: 'SchoolLocations',
  Campaigns: 'Campaigns',
  Locations: 'Locations',
  CostCentres: 'CostCentres',
  Categories: 'CATEGORIES',
  Regions: 'REGIONS',
  SchoolLocation: 'SCHOOLLOCATION',
  SchoolSubject: 'SCHOOLSUBJECTS',
  TxtTitle: 'txtTitle',
  Recruiter:'Recruiter',
}
export var LinkedControlName = {
  DepartmentID: 'DepartmentID',
  DIVISIONID: 'DIVISIONID',
  SchoolLocationsID: 'SchoolLocationsID',
  SchoolLocationID: 'SchoolLocationID',
  CampaignID: 'CampaignID'
};

export let DelWithdrawReasonTypes = {
  DelAppSection: 'DelAppSection',
  DelProfile: 'DelProfile',
  WithdrawSection: 'WithdrawSection'
};

export let SSOType = {
  Microsoft: 'Microsoft',
  Cas: 'Cas',
  Okta:'Okta'
};

export let DragDropEffect = {
  Copy: 'copy',
  Move: 'move'
};

export let SignatureType = {
  SimpleText: '',
  SignatureImage: '1'
};
export let NotifyTo = {
  Ask: 'Ask',
  Yes: 'Yes'
};
export let SearchDropdownType = {
  EmploymentType: 'EmploymentType',
  JobLevels: 'JobLevels',
  Category: 'Category',
  Salary: 'Salary',
  JobStatuses: 'JobStatuses',
  Locations: 'Locations',
  Region: 'Region',
  Departments: 'Departments',
  JobAccess: 'JobAccess',
  Agencies: 'Agencies',
  Division: 'Division',
  School: 'School',
  Employment: 'Employment',
  JobLevel: 'JobLevel',
  JobStatus: 'JobStatus',
  Location: 'Location',
  Department: 'Department',
  Agency: 'Agency',
  Recruiter: 'Recruiter',
};

export let SearchTypes = {
  SimpleSearch: 1,
  TalentSearch: 2,
  ForTalentPool: 'ForTalentPool',
  ForCandidates: 'ForCandidates',

};
export let ActionType = {
  Documents: 'Documents',
  NTUDocumentsExport: 'NTUDoc',
  MyJobs: 'myJobs',
  ManualInterview: "ManualInterview"
};
export let BottelNeckSelectedDays = {
  sevenDays: '7',
  thirtyDays: '30',
  nintyDays: '90',
};

export var OfferEmailEventType = {
  cc: "cc",
  bcc: "bcc",
  library: "library",
  browseAndAttach: "browseAndAttach"

}



export var AnonymousUser = {
  UserId: 1847483647,
  UserName: "Anonymous User"
}

export var KeywordSearch = {
  charLimit: 4

}

export var OfferApproval = {
  userArchived: 1

}
export var showInStarterForm = {
  Yes: 1,
  No: 0

}

export var isSecondStageForm = {
  Yes: 1,
  No: 0

}

export var FormFieldTypeId = {
  value: 10

}
export var SortColumn = {
  PositionName: "PositionName",
    Name: "Name",
    WorkPattrenName: "Name"


}
export var WordLimit = {
  Zero: "0",
  Twenty: "20",
}
export var MoveJobMsgType =
{
  Assigned: "Assigned",
  Error: "Error",
  AlreadyExist: "AlreadyExist",
  Failed: "Failed"
}
export var Path =
{
  Search: 'search'
}
export var PaymentType = {
  card: "card",
  bacsdebit: "bacs_debit"
}
export var Logos_Settings = {
  byDivisions: "ByDivisions",
  byDepartments: "ByDepartments",
  byCompany: "ByCompany",
}
export var DateFormats = {
  yyyyMMdd: "yyyy-MM-dd"
}
export var CultureVariant = {
  En_Us: "en_US"
}
export var UserInformation = {
  SigninDetails: 'SigninDetails'
}

export enum EducationSection {
  ProfessionalQualifications = 'Higher Education',
  CollegeQualifications = 'Secondary / Further Education',
}

export enum EventType {
  SendEmail='Send Email',
  AcknowledgementEmail='Acknowledgement Email',
  EmailSent='Email Sent',
  EMAIL='EMAIL',
  EmailQueued='Email Queued',
  CustomField='Custom Field',
  AdditionalInfo='Additional Info',
  Declaration='Declaration',
  EqualOpps='Equal Opps',
  Employment='Employment',
  JobApplications='Job Applications',
  Login='Login',
  CalendarEntry='Calendar Entry',
  BankDetails='BankDetails',
  SendingSMS='Sending SMS',
  SMS='SMS'
}
export var InterviewStateDuration = {
  Monthly: 'monthly',
  Weekly: 'weekly'
}
export var ReportLibraryFilterKeys = {
  reportName: 'ReportName',
  reportType: 'ReportType',
  dataSource: 'DataSource',
  createdBy: 'CreatedBy',
  archivedReports: 'ArchivedReports',
  includeAllReports: 'IncludeAllReports',
};




export var StarterDataStatus = {
  Completed: 1,
  Cancel: 2
}
export var EmailAndCalendarAcccountType = {
  Personal: 2,
  Corporate: 1
}

export var ClipboardMessageType = {
  ApplyLinkMessage: 1,
  LandingPageMessage:2
}
